import { useEffect, useRef, useState } from 'react';
import { SliderInput, SliderWrap, PitchWrap } from 'components/Slider/styles';

const pitchFractionToDegreeMap: Record<number, number> = {
	0: 0,
	1: 4.76,
	2: 9.46,
	3: 14.04,
	4: 18.43,
	5: 22.62,
	6: 26.57,
	7: 30.26,
	8: 33.69,
	9: 36.87,
	10: 39.81,
	11: 42.51,
	12: 45.0
};

const toRad = (deg: number) => (deg * Math.PI) / 180;
const toDeg = (rad: number) => (rad * 180) / Math.PI;

const getSliderlinearGrad = (val: number, active: boolean) =>
	`linear-gradient(to right, ${active ? 'var(--secondary)' : 'var(--sliderFillColor)'} 0%, ${active ? 'var(--secondary)' : 'var(--sliderFillColor)'} ${val}%, var(--sliderTrackColor) ${val}%, var(--sliderTrackColor) 100%)`;

export const getClosestFraction = (degree: number) => {
	let closestFraction = 0;
	let minDiff = Infinity;
	for (const fraction in pitchFractionToDegreeMap) {
		const diff = Math.abs(degree - pitchFractionToDegreeMap[Number(fraction)]);
		if (diff < minDiff) {
			minDiff = diff;
			closestFraction = Number(fraction);
		}
	}
	return closestFraction;
};

export const fractionToDegrees = (fraction: number) => {
	const f = Math.max(0, fraction);
	const deg = toDeg(Math.atan(f / 12));
	return parseFloat(deg.toFixed(1));
};

export const degreesToFraction = (degree: number) => {
	const deg = Math.max(0, degree);
	const f = 12 * Math.tan(toRad(deg));
	return parseFloat(f.toFixed(1));
};

export default function FractionalPitchSlider(props: {
  pitch: number,
  onChange?: (degree: number) => void,
  active: boolean,
  disabled?: boolean
}) {
	const initialFraction = degreesToFraction(props.pitch);
	const sliderRef = useRef<HTMLInputElement | null>(null);
	const [pitchval, setPitchVal] = useState<number>(initialFraction);

	useEffect(() => {
		setPitchVal(degreesToFraction(props.pitch));
	}, [props.pitch]);

	const percent = (Math.min(12, pitchval) / 12) * 100;

	return (
		<SliderWrap className='pitch-slider edit-fecet-slider fraction-slider-wrap'>
			<PitchWrap className="pitch-label fraction-pitch-label">
				<label>Pitch:</label>
				<span className="pitch-fraction">{Math.round(pitchval)}/12</span>
			</PitchWrap>
			<SliderInput
				type='range'
				className='facet-slider-range'
				min={0}
				max={12}
				step={1}
				value={pitchval}
				ref={sliderRef}
				disabled={props.disabled}
				style={{
					background: getSliderlinearGrad(percent, props.active)
				}}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					const value = +e.target.value;
					setPitchVal(value);
					const degree = pitchFractionToDegreeMap[value];
					props.onChange?.(degree);
				}}
			/>
		</SliderWrap>
	);
}
